import { createTheme } from "@mui/material";

const defaultTextTheme = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 16,
  fontWeight: 400,
  backgroundColor: 'white'
};

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
      fontWeight: 400
    },
    button: {
      textTransform: "none",
      ...defaultTextTheme
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: defaultTextTheme,
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        textTransform: "none",
        root: defaultTextTheme,
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        textTransform: "none",
        root: defaultTextTheme,
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "white",
          color: "black",
          fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
          fontSize: 12,
          maxHeight: '250px',
          maxWidth: '250px',
          border: '1px solid #EEF0FD',
          boxShadow: '2px 2px 4px 0px #DEE1F7'
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        root: {
          "&:focus": {
            outline: "none"
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: defaultTextTheme,
      },
    }
  },
});

export default theme;
